import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d4bf7794&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bf7794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4bf7794')) {
      api.createRecord('d4bf7794', component.options)
    } else {
      api.reload('d4bf7794', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d4bf7794&scoped=true&", function () {
      api.rerender('d4bf7794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Hu7SuLd9NOnc/JS/comp/Accordion.vue"
export default component.exports